import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip";
import type { NewLabelSuggestion, DropzoneFile } from "../types";

interface NewLabelSuggestionsProps {
  suggestions: NewLabelSuggestion[];
  file: DropzoneFile;
  onPropose: (suggestion: NewLabelSuggestion, file: DropzoneFile) => void;
}

export function NewLabelSuggestions({ suggestions, file, onPropose }: NewLabelSuggestionsProps) {
  if (!suggestions.length) return null;

  return (
    <div className="mt-1.5 pt-1.5 border-t border-dashed border-neutral-200">
      <span className="text-[10px] text-purple-600 font-medium block mb-1">Nieuw label voorstellen:</span>
      <div className="space-y-1">
        {suggestions.map((suggestion, idx) => (
          <TooltipProvider key={idx}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={() => onPropose(suggestion, file)}
                  className="w-full text-left flex items-center gap-2 px-2 py-1 rounded-md border border-dashed border-purple-300 bg-purple-50 hover:bg-purple-100 text-xs transition-colors"
                >
                  <span className="text-purple-500 flex-shrink-0">+</span>
                  <span className="flex-1 text-purple-700 font-medium">{suggestion.label}</span>
                  <span className={`px-1 py-0.5 rounded text-[9px] flex-shrink-0 ${suggestion.resourceType === 'unit' ? 'bg-blue-100 text-blue-700' : 'bg-neutral-100 text-neutral-600'}`}>
                    {suggestion.resourceType === 'unit' ? 'Unit' : 'Gebouw'}
                  </span>
                </button>
              </TooltipTrigger>
              <TooltipContent side="top" className="max-w-sm">
                <div className="text-xs">
                  <p className="font-medium">{suggestion.reason}</p>
                  <p className="text-neutral-500 mt-1">
                    Categorie: {suggestion.category}
                  </p>
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ))}
      </div>
    </div>
  );
}
